import { render, staticRenderFns } from "./r-exchange-rate-table.vue?vue&type=template&id=241b961f"
import script from "./r-exchange-rate-table.vue?vue&type=script&lang=js"
export * from "./r-exchange-rate-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('241b961f')) {
      api.createRecord('241b961f', component.options)
    } else {
      api.reload('241b961f', component.options)
    }
    module.hot.accept("./r-exchange-rate-table.vue?vue&type=template&id=241b961f", function () {
      api.rerender('241b961f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/exchange/r-exchange-rate-table.vue"
export default component.exports